import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Slider } from 'src/app/entities/slider';
import { BaseTableComponent } from '../base-table/base-table.component';
import { AlertService } from 'src/app/services/alert.service';
import { SliderService } from 'src/app/services/slider.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SliderComponent extends BaseTableComponent<Slider> implements OnInit {

  displayedColumns = ['id', 'title', 'clicks', 'views', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600',
      call: (item) => {
        return item.id;
      }
    },
    {
      key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: '',
      call: (item) => {
        return item.title;
      }
    },
    {
      key: 'clicks',
      type: 'integer',
      title: 'Clicks',
      classes: '',
      call: (item) => {
        return item.clicks;
      }
    },
    {
      key: 'views',
      type: 'integer',
      title: 'Impresiones',
      classes: '',
      call: (item) => {
        return item.views;
      }
    },
    {
      key: 'status',
      type: 'string',
      title: 'Estado',
      classes: '',
      call: (item) => {
        if(item.status == 1){
          return 'Activado';
        } else {
          return 'Desactivado';
        }
      }
    },
  ];

  constructor(
    protected sliderService: SliderService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = sliderService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}
